var map = {
	"./Slice 12@2x.png": "QWkn",
	"./Slice 13@2x.png": "oWcb",
	"./Slice 14@2x.png": "uK8t",
	"./Slice 15@2x.png": "NY6b",
	"./Slice 18@2x(1).png": "LsaP",
	"./Slice 18@2x(2).png": "KdOi",
	"./Slice 18@2x.png": "jmJt",
	"./baner1.png": "KXqx",
	"./baner2.png": "eHqF",
	"./baner3.png": "bgCJ",
	"./banner.png": "LGSj",
	"./demand.png": "DFuF",
	"./duijie.png": "q6fz",
	"./dynamicsBox.png": "J0uX",
	"./dynamicsJT.png": "ihXN",
	"./dynamicsbanner.png": "HEpg",
	"./fuwu.png": "CupB",
	"./fuwu1.png": "GKg0",
	"./fuwu2.png": "PFPQ",
	"./fwsB.png": "7DEs",
	"./gong.png": "ujaK",
	"./hbfw.png": "bcaO",
	"./jcfu.png": "R7z/",
	"./jrfu.png": "q8Gj",
	"./lbjjg.png": "DCU8",
	"./mjzz.png": "wvrd",
	"./myserver1.png": "ajFg",
	"./myserver2.png": "K/yS",
	"./myserver3.png": "p2n4",
	"./offlinebanner.png": "6DZ2",
	"./pingjia.png": "Vln5",
	"./qiatan.png": "CCA6",
	"./qtfw.png": "6rV8",
	"./sbzz.png": "JVx4",
	"./server.png": "o8+2",
	"./serverShop1.png": "8P6K",
	"./serverShop2.png": "Nc+b",
	"./serverShop3.png": "Pnqk",
	"./serverShop4.png": "lfEU",
	"./serverShop5.png": "avl4",
	"./serverShop6.png": "2TH2",
	"./serverShop7.png": "ik4r",
	"./xiaoshou.png": "WN8t",
	"./xu.png": "IarK",
	"./znhfw.png": "tkoe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+k72";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome ^\.\/.*\.png$
// module id = +k72
// module chunks = 2